module.exports = __webpack_public_path__ + "media/assets/images/smart_working/personas-2-0b1518226e6eac2e9c1c7cceb4e72da3.jpg";